import Quill from 'quill';
import QuillResize from 'quill-resize-module';
import 'quill-resize-module/dist/resize.css';

let registered = false;

/** 仅注册一次，供文献笔记等富文本在插入图片后可拖拽调整尺寸 */
export function ensureQuillResizeRegistered(): void {
  if (registered) return;
  Quill.register('modules/resize', QuillResize, true);
  registered = true;
}
